import PageWrapper from "@/components/PageWrapper";
import { GenericEventEmailCollectionPage } from "modules/event-registration/generic-event-email-collection";

const Page = () => {
  // Currently, the JWT domain does not include "www.". v2 event links do not contain "www." in the URL, but v1 event links do. This means that a candidate who's logged into Forward that gets sent a link with "www." will not be treated as "logged in"
  // As a quick fix for September release, we're redirecting the "www." page to the non-"www." one. I couldn't figure out a way to do this with Next router or with getServerSideProps (I couldn't get this SO solution to work https://stackoverflow.com/a/68508426)
  if (window.location.href.match(/^https*:\/\/www/) !== null) {
    window.location.replace(
      window.location.href.replace(
        // Only replace first instance of "www.", so no "g" flag in the regex; the "www." subdomain in the URL will always be matched first
        /www./,
        ""
      )
    );
    return (
      <PageWrapper title="Event Registration">
        <></>
      </PageWrapper>
    );
  }
  return <GenericEventEmailCollectionPage />;
};

export default Page;
